import type { ReviewCommentRecord } from '@mesa/core/review';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface OutdatedCommentIndicatorProps {
  comment: ReviewCommentRecord;
  className?: string;
}

export function OutdatedCommentIndicator({ comment, className }: OutdatedCommentIndicatorProps) {
  if (!comment.isOutdated) {
    return null;
  }

  return (
    <Badge variant="secondary" className={cn('bg-yellow-100 text-yellow-800 border-yellow-300 text-xs', className)}>
      Outdated
    </Badge>
  );
}
